export default {
  title: {
    en: 'Let’s Try This Again.',
  },
  text: {
    en: `
        An error occurred when we tried to process your payment. Please re-enter
        your information, or choose a different payment method. Still having
        problems? Feel free to reach out to our customer support team at
        <Link mailto="support@scentbird.com">support@scentbird.com</Link>!
      `,
  },
  button: {
    en: 'Re-enter info',
  },
}
